export default "__VITE_ASSET__vK9DRBb5__"